import {
  common_v1_ObjectMeta,
  core_v1_DataSource,
} from '@antimatterhq/asl-api-ts-v1';
import { produce } from 'immer';
import { CustomFunction } from './customFunction';
import { TableMode } from '@/zod/schemas/dataSource/Common';

export const initDataSource = () => {
  const dataSource: core_v1_DataSource = {
    spec: {
      schedule: {
        atLeastEvery: '10m',
      },
    },
  };

  return dataSource;
};

export const filterStringArray = (values: (string | undefined)[] = []) => {
  const filtered = values.filter((v) => !!v) as string[];
  if (filtered.length === 0) {
    return undefined;
  }
  return filtered;
};

export const bumpVersion = <
  T extends { metadata?: common_v1_ObjectMeta | null },
>(
  data: T,
): T => {
  return produce(data, (draft) => {
    if (!draft.metadata) {
      draft.metadata = {
        name: '',
      };
    }
    draft.metadata = {
      ...draft.metadata,
      version: (draft.metadata?.version ?? 0) + 1,
    };
  });
};

export const getMode = (
  name: string,
  custom: CustomFunction,
  omitTables: string[],
): TableMode => {
  if (omitTables.includes(name)) {
    return 'disable';
  }

  if (custom?.function) {
    return 'custom';
  }

  return 'configure';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deepEqual = (obj1: any, obj2: any): boolean => {
  // Special case: if both values are primitive
  if (
    obj1 === null ||
    obj1 === undefined ||
    obj2 === null ||
    obj2 === undefined ||
    typeof obj1 !== 'object' ||
    typeof obj2 !== 'object'
  ) {
    // Handle null/undefined equivalence
    if (
      (obj1 === null || obj1 === undefined) &&
      (obj2 === null || obj2 === undefined)
    ) {
      return true;
    }
    // For other primitives, check strict equality
    return obj1 === obj2;
  }

  // Get all keys from both objects
  const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

  for (const key of allKeys) {
    const val1 = obj1[key];
    const val2 = obj2[key];

    // If both are undefined or null, continue
    if (
      (val1 === undefined || val1 === null) &&
      (val2 === undefined || val2 === null)
    ) {
      continue;
    }

    // Recursive check for nested objects
    if (!deepEqual(val1, val2)) {
      return false;
    }
  }

  return true;
};
